import React from "react";
import Lottie from "lottie-react";
import errorAnimation from "../assets/lottie/error.json";

const ErrorPage = () => {
  return (
    <div
      style={{
        minHeight: "calc(96vh - 103px)",
        alignContent: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ maxWidth: "600px" }}>
        <Lottie
          animationData={errorAnimation}
          loop={true}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </div>
    </div>
  );
};

export default ErrorPage;
